export const BIG_NAV_PX_HEIGHT = 60;
export const SMALL_NAV_PX_HEIGHT = 70;
export const SUB_NAV_PX_HEIGHT = 56; //mobile-only, eg /guide
export const FONT_FAMILY_DISPLAY = `'Charlie Display', sans-serif`;
export const FONT_FAMILY_TEXT = `'Charlie Text', sans-serif`;
// Source: https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/design-system/theme/src/constants.tsx
export const FONT_FAMILY_SYSTEM = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;
export const FONT_FAMILY_CODE = `'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace`;
//# sourceMappingURL=constants.js.map